import isEmpty from 'lodash/isEmpty';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import * as api from 'dashboard/resources/lottery-representatives.api';
import template from './lottery-representatives-widget.html';

const mapStateToThis = ({ session }) => {
  const { retailer } = session;

  return {
    retailer,
  };
};

const mapDispatchToThis = {};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', '$state')
class LotteryRepresentativesWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    const transformData = ({ representatives }) =>
      representatives.map((rep) => {
        const initials = `${rep.firstName.charAt(0)}${rep.lastName.charAt(0)}`;
        return {
          initials,
          ...rep,
        };
      });
    this.loadDataAsync(() => api.fetchLotteryRepresentatives(retailerId), transformData, 'representatives');
  }

  $onDestroy() {
    this.unsubscribe();
  }
}

export default class LotteryRepresentativesWidgetComponent {
  constructor() {
    this.bindings = {
      isEditMode: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
    this.template = template;
    this.controller = LotteryRepresentativesWidgetController;
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/lottery-representatives/lottery-representatives-widget-component.js